import type { HTMLAttributes, ReactNode } from 'react'

import type { TypographyProps } from '../typography'
import { Typography } from '../typography'

type Props = {
  children: ReactNode
} & HTMLAttributes<HTMLParagraphElement> &
  TypographyProps

export const ModalContentText = ({ children, ...other }: Props) => (
  <Typography data-testid="modal-content-text" variant="h3" {...other}>
    {children}
  </Typography>
)
